import { graphql } from 'react-relay';

/**
 * The Data health read model (pv-mono#1179): pv-data's `reporting.data_freshness`, read fresh on every
 * load. Unfiltered on purpose: the counts are over every row anyway, and filtering the rows client-side
 * keeps the domain / status controls instant. The rows arrive worst first; the view sorts again so the
 * page's order never depends on the server's.
 *
 * Lives in `relay/` so the `graphql` tag stays in modules that go through the Babel transform.
 */
export const dataHealthQuery = graphql`
    query dataHealthQuery {
        dataHealth {
            generatedAt
            lastWrittenAt
            liveTier
            counts {
                red
                amber
                green
                frozen
                total
            }
            domains
            scheduler {
                kind
                name
                domain
                status
                frozen
                attention
                attentionDetail
                versionHeld
                publisherLatest
                lastSuccessAt
                lastOutcome
                nextDueAt
                durationSeconds
                expiresOn
                writtenAt
            }
            rows {
                kind
                name
                domain
                status
                frozen
                attention
                attentionDetail
                versionHeld
                publisherLatest
                publisherLatestAt
                lastSuccessAt
                lastOutcome
                nextDueAt
                durationSeconds
                expiresOn
                writtenAt
            }
            dueDrops {
                kind
                name
                domain
                status
                frozen
                attention
                attentionDetail
                versionHeld
                publisherLatest
                lastSuccessAt
                nextDueAt
                durationSeconds
                expiresOn
                writtenAt
            }
            expiring {
                name
                domain
                expiresOn
                daysLeft
                expired
            }
            nextExpiry {
                name
                domain
                expiresOn
                daysLeft
                expired
            }
        }
    }
`;
